import VacancyPage from "../../vacancies/ui/pages/VacancyPage"

const RecruitmentPage = () => {
  return (
    <div>
      <VacancyPage />
    </div>
  )
}

export default RecruitmentPage
